module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./FirstClassView.js"));
	}, "FirstClassView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FirstClassView!./src/pages/Shop/Home/FirstClass/FirstClassView.js
// module id = 932
// module chunks = 438